import styled from '../../../../../styles/styledComponents/themeComponents';
import SearchBox from '../../../../../components/outline/SearchBox';

export const OrderManagementSearchBoxStyle = styled(SearchBox)`
  .amondz-select {
    vertical-align: top;
    width: 200px;

    &:not(:last-child) {
      margin-right: 15px;
    }
  }

  .amondz-textArea {
    width: 700px;
  }

  .quick-date-picker,
  .date-search {
    display: inline-block;
  }
`;
